import { CALL_DINAMIC_DISABLE_LOTE, CLOSE_MODALES, DATA_ANULATION_FORM, DATA_MODAL_DESCARGAR_DATOS, ERROR_GENERAL, INIT_OPEN_COMPONENT_REPORTS, LOAD_DOCUMENT_SUCCESS, MESSAGE_ALERT_SEND, MESSAGE_ANULATION_FORM_RYA, MESSAGE_CONFIRMATION_SEND, OCULTAR_DEVOLUCIONES, OPEN_ANULATION_FORM, OPEN_FORM_BANDEJA, OPEN_HISTORIAL_BANDEJA, OPEN_MODAL_CHARGED, RETURN_HOME_BANDEJA, SAVED_INFO_USER_BANDEJA, SAVE_CONSULTA_REPORTS, SAVE_PDF_RELATIONS_WORKERS, SAVE_STATE_AFILIACION_FORM_COMPANY, SEND_MESSAGE_CONFIRMATION_RYA, SET_DATA_PAGINAR_REG_EMPRESAS, SET_DATA_PAGINAR_REPORTS_EMPRESAS, TYPE_USER_BANDEJA, UPDATE_MSG_SOLICITUD, VALIDATE_USER_TYPE_SUCCESS } from "./constants";

export function setDataPaginarRegEmpresas(payload) {
    return {
        type: SET_DATA_PAGINAR_REG_EMPRESAS,
        payload
    };
}

export function setDataPaginarReportsEmpresas(payload) {
    return {
        type: SET_DATA_PAGINAR_REPORTS_EMPRESAS,
        payload
    };
}

export function openFormBandeja(payload) {
    return {
        type: OPEN_FORM_BANDEJA,
        payload
    };
}

export function errorGeneral(payload) {
    return {
        type: ERROR_GENERAL,
        payload
    };
}

export function ocultarDevoluciones(payload) {
    return {
        type: OCULTAR_DEVOLUCIONES,
        payload
    };
}

export function messageAlertSend(payload) {
    return {
        type: MESSAGE_ALERT_SEND,
        payload
    };
}

export function messageAnulationFormRya(payload) {
    return {
        type: MESSAGE_ANULATION_FORM_RYA,
        payload
    };
}

export function saveConsultaReports(payload) {
    return {
        type: SAVE_CONSULTA_REPORTS,
        payload
    };
}

export function updateMsgSolicitud(payload) {
    return {
        type: UPDATE_MSG_SOLICITUD,
        payload
    };
}

export function messageConfirmationSend(payload) {
    return {
        type: MESSAGE_CONFIRMATION_SEND,
        payload
    };
}

export function savedInfoUserBandeja(payload) {
    return {
        type: SAVED_INFO_USER_BANDEJA,
        payload
    };
}

export function validateUserTypeSuccess(payload) {
    return {
        type: VALIDATE_USER_TYPE_SUCCESS,
        payload
    };
}

export function returnHomeBandeja(payload) {
    return {
        type: RETURN_HOME_BANDEJA,
        payload
    };
}

export function openHistoryBandeja(payload) {
    return {
        type: OPEN_HISTORIAL_BANDEJA,
        payload
    };
}

export function typeUserBandeja(payload) {
    return {
        type: TYPE_USER_BANDEJA,
        payload
    };
}

export function openAnulationForm(payload) {
    return {
        type: OPEN_ANULATION_FORM,
        payload
    };
}

export function dataAnulationForm(payload) {
    return {
        type: DATA_ANULATION_FORM,
        payload
    };
}

export function sendMessageConfirmationRya(payload) {
    return {
        type: SEND_MESSAGE_CONFIRMATION_RYA,
        payload
    };
}

export function loadDocumentSuccess(payload) {
    return {
        type: LOAD_DOCUMENT_SUCCESS,
        payload
    };
}

export function openModalCharged(payload) {
    return {
        type: OPEN_MODAL_CHARGED,
        payload
    };
}

export function closeModales(payload) {
    return {
        type: CLOSE_MODALES,
        payload
    };
}

export function initOpenComponentReports(payload) {
    return {
        type: INIT_OPEN_COMPONENT_REPORTS,
        payload
    };
}

export function callDinamicDisableLote(payload) {
    return {
        type: CALL_DINAMIC_DISABLE_LOTE,
        payload
    };
}

export function dataModalDescarDatos(payload) {
    return {
        type: DATA_MODAL_DESCARGAR_DATOS,
        payload
    };
}

export function saveStateAfiliacionFormCompany(payload) {
    return {
        type: SAVE_STATE_AFILIACION_FORM_COMPANY,
        payload
    };
}

export function savePdfRelationsWorkers(payload) {
    return {
        type: SAVE_PDF_RELATIONS_WORKERS,
        payload
    };
}